export const isProd = () => {
  return process.env.REACT_APP_ENVIRONMENT === "prod";
};

export const isOutsideBusinessHours = () => {
  const now = new Date();
  const day = now.getDay(); // 0: Sunday, 1: Monday, ..., 6: Saturday
  const hour = now.getHours();
  const minutes = now.getMinutes();
  const time = hour + minutes / 60;

  // Sunday
  if (day === 0) {
    return true;
  }

  // Saturday: 7 AM - 12 PM
  if (day === 6) {
    return time < 7 || time >= 12;
  }

  // Weekdays (Monday-Friday): 7 AM - 7 PM
  return time < 7 || time >= 19;
};

export const makeStartDate = (d: Date): Date => {
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);

  return d;
};

export const makeEndDate = (d: Date): Date => {
  d.setHours(23);
  d.setMinutes(59);
  d.setSeconds(59);
  d.setMilliseconds(999);

  return d;
};

export const startDateBefore = 7;
export const startDateAfter = 7;

export const reduceText = (text: string, visibleCount: number) => {
  return text.length > visibleCount
    ? text.substring(0, visibleCount - 3) + "..."
    : text;
};

export const motorcycle = "오토바이";
export const damas = "다마스";
export const labo = "라보";
export const axle = ["축카고", "윙축", "축카고/축윙"];
export const motorcycleWeight = 10;
export const damasWeight = 0.3;
export const laboWeight = 0.5;
export const axleWeight = 5; //축 차량 무게

export const getDateFormat = () => "yyyy년 MMMM d일";

export const getVehicleTypes = () => {
  return [
    "카고/윙바디",
    "축카고/축윙",
    "카고",
    "윙바디",
    "축카고",
    "윙축",
    "오토바이",
    "다마스",
    "라보",
    "탑",
    // '초장축',
    // '호루',
    // '냉동탑',
    "리프트",
    "리프트윙",
    // '냉장윙',
    // '냉장윙축',
    // '무진동',
    // '추레라',
  ];
};

export const cargoCategory = [
  "카고",
  "플축카고",
  "축카고",
  "초장축",
  "리프트",
  "플러스카",
];
export const wingCategory = [
  "윙바디",
  "플축윙",
  "윙축",
  "플러스윙",
  "리프트윙",
  "플축윙리",
  "냉장플축윙",
  "냉동플축윙",
  "냉장윙",
  "냉장윙축",
  "냉동윙",
  "냉동윙축",
  "초장축윙",
];
export const topCategory = ["탑", "냉장탑", "냉동탑"];

export const smallVehicleType = ["다마스", "라보"];
export const bigVehicleType = [
  "카고",
  "윙바디",
  "플축카고",
  "플축윙",
  "축카고",
  "탑",
  "초장축",
  "초장축윙",
  "호루",
  "냉동탑",
  "플러스카",
  "플러스윙",
  "윙축",
  "리프트",
  "리프트윙",
  "플축윙리",
  "무진동",
  "추레라",
  "냉장플축윙",
  "냉장윙",
  "냉장윙축",
  "냉동플축윙",
  "냉동윙",
  "냉동윙축",
  "기타",
];

export const getVehicleWeights = () => {
  return [1, 1.4, 2.5, 3.5, 5, 11, 18, 25];
};

export const getPackagingTypes = () => {
  return ["pt", "box", "etc"];
};

export const getLoadingTypes = () => {
  return ["forklift", "crane", "hand", "etc"];
};

export const getStatusList = () => {
  return [
    { id: 0, status: "배차중" }, // 주문완료와 동시에 배차시작이라 주문완료와 동일한 의미로 사용
    { id: 1, status: "배차완료" },
    { id: 2, status: "운송완료" },
    { id: 3, status: "정산완료" },
    { id: 10, status: "주문취소" }, // 배차완료 전 취소
    { id: 11, status: "배차취소" }, // 배차완료 후 취소
  ];
};

export const insertZeroTo = (num: number): string => {
  const numStr = num.toString();
  if (num < 10) {
    return "0" + numStr;
  }

  return numStr;
};

export const convertDateWithKorean = (d: Date): string => {
  if (d.getTime() === 0) return "";

  // const d = new Date(dt);
  const month = insertZeroTo(d.getMonth() + 1);
  const day = insertZeroTo(d.getDate());
  const hour = insertZeroTo(d.getHours());
  const minute = insertZeroTo(d.getMinutes());

  return `${month}월 ${day}일 ${hour}:${minute}`;
};

export const convertDate = (d: Date): string => {
  if (d.getTime() === 0) return "";

  // const d = new Date(dt);
  const year = d.getFullYear();
  const month = insertZeroTo(d.getMonth() + 1);
  const day = insertZeroTo(d.getDate());
  const hour = insertZeroTo(d.getHours());
  const minute = insertZeroTo(d.getMinutes());

  return `${year}-${month}-${day} ${hour}:${minute}`;
};

export const changeVehicleWeight = (type: string, weight: any) => {
  if (type === "오토바이") return "10kg";

  return weight + "톤";
};

export const changePackagingType = (type: string) => {
  if (type === "pt") return "파레트";
  if (type === "box") return "박스";
  if (type === "etc") return "기타";

  return "";
};

export const changeLoadingType = (type: string) => {
  if (type === "crane") return "크레인";
  if (type === "forklift") return "지게차";
  if (type === "hand") return "수작업";
  if (type === "etc") return "기타";

  return "";
};

export const sortOrder = (orderType: string, orderBy: string) => {
  return (a: any, b: any) => {
    if (orderType === "desc") {
      if (a[orderBy] > b[orderBy]) {
        return -1;
      } else if (a[orderBy] < b[orderBy]) {
        return 1;
      } else {
        return 0;
      }
    }

    if (a[orderBy] > b[orderBy]) {
      return 1;
    } else if (a[orderBy] < b[orderBy]) {
      return -1;
    } else {
      return 0;
    }
  };
};

export const convertPhone = (phone: string): string => {
  let p = phone.replace(/[^0-9]/g, "");
  p = p.replace(
    /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
    "$1-$2-$3"
  );
  p.replace("--", "-");

  return p;
};

export const validatePhone = (phone: string): boolean => {
  const regExp = /^\d{2,3}-\d{3,4}-\d{4}$/;
  return regExp.test(phone);
};

export const validateAddress = (
  departureAddressBase: string,
  arrivalAddressBase: string
): boolean => {
  return departureAddressBase !== arrivalAddressBase;
};

export const convertOption = (
  optionBackDoorOpen: boolean,
  optionForklift: boolean,
  optionShuttle: boolean,
  optionMultiple: boolean,
  orderCount: number,
  orderInterval: number,
  optionMixedLoading: boolean,
  optionCashOnDelivery: boolean
): string => {
  const res = [];

  if (optionMixedLoading) res.push("혼적가능");
  if (optionBackDoorOpen) res.push("뒷문개방");
  if (optionForklift) res.push("지게차 운전 가능한 기사님");
  if (optionShuttle) res.push("왕복");
  if (optionMultiple)
    res.push(`복수배차(${orderInterval}분 간격/${orderCount}건)`);
  if (optionCashOnDelivery) res.push(`착불`);

  return res.join(" | ");
};

export const addCommaToEvery3Digits = (n: number): string => {
  return n.toLocaleString();
};

export const changeDocumentTitle = (title: string) => {
  return (document.title = title);
};
